import { TypographyComponent } from 'src/components/Typography'
import styled, { css } from 'styled-components'

export const ContainerFlex = styled('form')(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.layout.gap.base * 10}rem;
    width: 100%;
    justify-content: center;

    @media (max-width: ${theme.screen.large}) {
      max-width: 100%;
    }
  `
)

export const Content = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.layout.gap.base * 5}rem;
    width: 70%;

    @media (max-width: ${theme.screen.large}) {
      width: 100%;
    }
  `
)

export const FormTitle = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.typograph.fontsize.h6};
      line-height: ${theme.layout.lineHeight.big}rem;
      color: ${theme.colors.font.title};
    }
  `
)

export const HelperText = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      color: ${theme.colors.error.main};
      font-size: ${theme.typograph.fontsize.h1};
    }
  `
)
